// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 797 ? "npm.intl" : chunkId) + "." + {"482":"2f0698dfd0e706c24c7f","797":"9a263d2e337da0b1a42e","867":"186644d63a9396b212b3"}[chunkId] + ".chunk.js";
};